import { Component, Input, OnInit } from "@angular/core";
import { ContactList } from "../../../../models/contact-list.model";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "src/app/pages/users/services/user.service";
import { User } from "src/app/pages/users/models/user.model";
import { Subject, takeUntil } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AtendenteService } from "../../../atendente.service";
import { Atendente } from "../../../../models/atendente.model";

@Component({
  selector: "app-add-attendant-modal",
  templateUrl: "./add-attendant-modal.component.html",
  styleUrl: "./add-attendant-modal.component.scss",
})
export class AddAttendantModalComponent implements OnInit {
  private readonly destroy$ = new Subject<void>();
  @Input() list!: ContactList;

  users: User[] = [];
  atendentes: Atendente[] = [];
  atendentes$ = this.atendenteService.atendentes$;
  vincularUsuarioForm!: FormGroup;
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private fb: FormBuilder,
    private atendenteService: AtendenteService
  ) { }

  ngOnInit(): void {

    this.consultarUsuariosEAtendentesJaVinculados(this.list.id);
    
    this.iniciarForm();
  }

  iniciarForm(): void {
    this.vincularUsuarioForm = this.fb.group({
      usuarioId: ['', Validators.required],
      listaContatoGeradoid: [this.list.id]
    })
  }
  
  onSubmit(): void {
    if (this.vincularUsuarioForm.invalid) {
      this.vincularUsuarioForm.markAllAsTouched();

      return;
    }
    this.isLoading = true

    let valoresFormulario = this.vincularUsuarioForm.value;

    let novoAtendente = {
      id: valoresFormulario.usuarioId
    };

    this.atendenteService.adicionarAtendente(novoAtendente, valoresFormulario.listaContatoGeradoid).subscribe({
      next: (response) => {
        this.consultarUsuariosEAtendentesJaVinculados(valoresFormulario.listaContatoGeradoid);
      },
      error: (error) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  excluirAtendente(atendenteId: string):void {
    this.atendenteService.excluirAtendente(atendenteId, this.list.id).subscribe({
      next:() => {
        this.isLoading = true

        this.consultarUsuariosEAtendentesJaVinculados(this.list.id);
      },
      error: (error) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  private consultarUsuariosEAtendentesJaVinculados(listaId: string) {
    this.atendenteService.carregarAtendentes(listaId).subscribe({
      next: (response) => {
        this.atendentes = response;
  
        // Somente após carregar os atendentes, buscar os usuários e filtrar
        this.userService.rows$.pipe(takeUntil(this.destroy$)).subscribe({
          next: (users) => {
            this.users = users
          },
          error: (error) => {
            console.error(error);
          },
        });
      },
      error: (error) => {
      }
    });
  }
}
